import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'p-static-progress-bar',
    template: `
        <div class="p-static-progress-bar">
            <p-link *ngIf="label && isLink" class="p-static-progress-bar-label p-paragraph-1 progress-label" (onClick)="linkClicked.emit()">
                {{ label }}
            </p-link>
            <p *ngIf="label && !isLink" class="p-static-progress-bar-label p-paragraph-1 progress-label">
                {{ label }}
            </p>
            <mat-progress-bar class="p-static-progress-bar-line" mode="determinate" [value]="value"></mat-progress-bar>
        </div>
    `,
    styleUrls: ['./p-static-progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PStaticProgressBarComponent {
    @Input() label?: string;
    @Input() value?: number;
    @Input() isLink = false;
    @Output() linkClicked = new EventEmitter();
}
